<template>
    <div>
        <div class="header">
            <h1><img alt="logo" src="../../assets/logo.png"></h1>
            <div class="headerNav">
                <a target="_blank" href="http://www.ystwl.com.cn/">首页</a>
            </div>
        </div>
        <div class="banner">
            <div class="login-aside">
                <div id="o-box-up"></div>
                <div id="o-box-down" >
                    <div>
                        <div class="form-label">云速通TMS系统登陆：</div>
                        <el-input v-model="LoginName" placeholder="请输入内容" style="width:242px;"></el-input>
                    </div>
                    <div>
                        <div class="form-label">登陆密码：</div>
                        <el-input type="password" v-model="Password" placeholder="请输入内容" style="width:242px;" @keyup.enter.native="loginMethod"></el-input>
                    </div>
                    <div>
                        <div class="form-label">&nbsp;</div>
                        <el-button  class="btn-login"  @click.native.prevent="loginMethod" :loading="logining"></el-button>
                    </div>
                </div>
            </div>
            <div class="bd">
                <ul>
                    <img src="../../assets/images/login_pic.jpg" style="width:100%;" />
                </ul>
            </div>
            <div class="hd"><ul></ul></div>
        </div>
        <div class="banner-shadow"></div>
        <div class="footer">
            <p>Copyright 2008-2020 YST Logistics CO., LTD</p>
        </div>
    </div>
</template>

<script>
 import LoginJs from "./Login.js";
    export default LoginJs;
</script>

<style scoped>

/*---------------------reset----------------------*/
html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, font, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td { margin:0; padding:0; border:0; outline:0;}
ol, ul, li { list-style:none } 
body { background:#FFF;}
:focus { outline:0 }
* html .clearfix { zoom:1 }
*+html .clearfix { zoom:1 }
.clearfix:after {clear: both;content: ".";display: block;height: 0;overflow: hidden;visibility: hidden;}
.pos-r{ position:relative;}
/*---------------------header----------------------*/
.header{ height: 84px; margin:26px auto; overflow: hidden; position: relative; width: 100%; z-index: 2;text-align: left;}
.headerNav { right: 0;text-align: right;top: 62px; width: 300px; position:absolute;}
.headerNav a{ color:#515151; font-size:12px; padding:0 20px;}
.headerNav a:hover{ text-decoration:underline; color:#658b98;}
/*---------------------banner----------------------*/
.banner{ min-width:1000px;  position:relative;  height:478px; overflow:hidden; }
.banner .bd{ position:relative; z-index:3; }
.banner .bd ul{ width:100% !important; }
.banner .bd li{ width:100% !important;  height:478px; }
.banner .bd li .siteWidth{ width:1000px; position:relative;  margin:0 auto;  height:299px;  }
.banner .bd li a{ height:299px; display:block;  }
.banner .bd .txt{ position:absolute; width:415px; top:100px; left:22px;   font:normal 18px/30px "Microsoft YaHei";    }

.banner-shadow{ height:50px; line-height:50px; background:url(../../assets/images/banner-shdow.png) repeat-x;}
.footer{text-align:center; font-size:12px; color:#999999;}
.login-aside{position:absolute; width:320px; height:380px; z-index:4; border-radius:5px; left:58%; top:40px; }

.form-label {
    display: block;
    float: none;
    height: auto;
    line-height: 12px;
    text-align: left;
    width: auto;
	font-size:14px;
	color:rgb(2, 92, 20);
	font-weight:bold;
	/* text-shadow:1px 1px 1px #4e6877;
	-o-text-shadow:1px 1px 1px #4e6877;
	-o-moz-shadow:1px 1px 1px #4e6877;
	-o-mis-shadow:1px 1px 1px #4e6877;
	-o-webkit-shadow:1px 1px 1px #4e6877; */
	margin-top:16px;
	margin-bottom:16px;
}

#o-box-up,#o-box-down {
    width:320px;
    height:380px;
    position:absolute;
	border-radius:5px;
}
#o-box-up {
    background-color:#ffffff;
    filter:alpha(opacity:40);
    opacity:0.9;
}
 
#o-box-down{ padding:40px 0 0 40px; text-align: left;}

 
 .yzm{ width:112px;}
 .yzm-img{ position:absolute; left:130px; top:30px; cursor:pointer;}

.btn-login{ width:242px; height:38px; background:url(../../assets/images/login-btn.png) no-repeat; border:none; margin-top:5px;}



</style>


// WEBPACK FOOTER //
// src/components/Login/Login.vue